var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.recurrencies,"item-text":"title","item-value":"id","label":"Періодичність","return-object":"","hide-details":"","menu-props":{
    nudgeRight: 30,
    transition: 'scale-transition',
    offsetY: '',
  },"dense":"","outlined":""},on:{"input":_vm.selectRecurrence},model:{value:(_vm.selectedRecurrence),callback:function ($$v) {_vm.selectedRecurrence=$$v},expression:"selectedRecurrence"}})}
var staticRenderFns = []

export { render, staticRenderFns }